import { R_POR } from '@lba-dev/package.local-globals/remStatus';

const remunerationText = (remuneration) =>
  remuneration &&
    (remuneration.status === R_POR ?
      `MO: ${remuneration.pourcentage.labor} %`
      : '€')

export default remunerationText;
